import React, { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { BigSlideWrap, BigSlideContainer } from '../style';

const SlideSection = ({ bigBannerContents = [] }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const isMultiBanner = bigBannerContents.length > 1;

  const settings = {
    infinite: isMultiBanner,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: isMultiBanner,
    autoplay: isMultiBanner,
    autoplaySpeed: 5000,
    useTransform: false,
    arrows: false, // 화살표 숨김
    draggable: isMultiBanner, // 배너가 한 개면 드래그 불가능
    swipe: isMultiBanner, // 배너가 한 개면 터치 스와이프 불가능
    beforeChange: (_, nextIndex) => {
      setCurrentPage(nextIndex + 1);
    },
  };

  const MediaSlide = ({ slideData = {} }) => {
    const [mousePosition, setMousePosition] = useState({
      clientX: 0,
      clientY: 0,
    });

    const isVideo = slideData.orgFileNm?.endsWith('.mp4');

    return (
      <BigSlideContainer bgUrl={slideData.thumbnailImageFileUrl}>
        <a
          href={slideData.movementUrl}
          onClick={e => {
            if (
              mousePosition.clientX !== e.clientX ||
              mousePosition.clientY !== e.clientY
            ) {
              e.preventDefault();
            }
          }}
          onMouseDown={e => {
            setMousePosition({ clientX: e.clientX, clientY: e.clientY });
            e.preventDefault();
          }}
          target="_blank"
        >
          {isVideo ? (
            <video loop muted playsInline autoPlay>
              <source src={slideData.fileUrl} type="video/mp4" />
            </video>
          ) : (
            <img
              src={slideData.fileUrl}
              alt={`메인 빅배너_${slideData.orgFileNm}`}
            />
          )}
          <div className="textWrap">
            <p>{slideData.firstTitle}</p>
            <p>{slideData.secondTitle}</p>
            <p className="sub">{slideData.firstSubTitle}</p>
            <p className="sub">{slideData.secondSubTitle}</p>
            <p className="sub">{slideData.thirdSubTitle}</p>
          </div>
        </a>
      </BigSlideContainer>
    );
  };

  return (
    <BigSlideWrap className="bigSlideWrap">
      <Slider {...settings}>
        {bigBannerContents.map((data, index) => (
          <MediaSlide key={index} slideData={data} />
        ))}
      </Slider>
      {isMultiBanner && (
        <div className="pageCounter">
          <span>{currentPage}</span>
          <span>/</span>
          <span>{bigBannerContents.length}</span>
        </div>
      )}
    </BigSlideWrap>
  );
};

export default SlideSection;
